module.exports = __webpack_public_path__ + "media/bgm.b3da9481.mp3";